<template lang="pug">
  .analise
    h3.titulo-cadastar-foto Vincular fotos a cadastros Reurb
    el-card.card-container(shadow="hover")
      filtro(
        @pesquisar="pesquisar",
        @limpar="clearFiltro",
        :configuracaoFiltro="configuracaoFiltro"
      )
    app-listagem(
      :has-refresh-button="true",
      :showButtonOrdemServico="false",
      :showButtonAssinatura="false",
      :has-expansivel="false",
      :json-headers="colunas",
      :json-data="items",
      :totalElements="totalElements",
      :pagina="filtro.pagina",
      :hasFiltroRapido="true",
      :filtro="filtro"
      @atualizarFiltro="atualizarFiltro"
      @updateListagem="refresh",
      @changePage="changePage",
      @sort="sort",
      @executar="executar",
    )
    app-modal-visualizar-completo(
      v-if="showModalVisualizarProcesso && idProcesso !== null",
      @closeModal="showModalVisualizarProcesso = false",
      :idProcesso="idProcesso",
      :protocolo="protocolo",
      :numeroProcesso="numeroProcesso",
      :tipo="tipoProcesso"
    )
    app-modal(
      v-if="showModal"
      :modalNova="true",
      :closeOutside="true",
      :titulo="titulo",
      :width="980",
      @closeModal="closeModal()"
    )
      template(slot="body")
        app-anexo(
          :id="'upload-atualizacao-base'"
          @uploadFile="uploadFile",
          :files="anexos",
          @removeFile="removeFile"
          @downloadDocumentoCadastro="downloadDocumentoCadastro"
          :fileType="['png', 'jpg', 'jpeg']"
        )
      template(slot="footer")
        div.buttons
          el-button(
            type="primary",
            key="botao-confirma",
            @click="adicionarFotos()"
          ) Salvar fotos no processo
</template>
<script>

import FileSaver from 'file-saver'
import Filtro from '@/screens/analise/listagem/Filtro'
import AppAnexo from '@/components/AppAnexo'
import AppListagem from '@/components/AppListagem'
import AppModal from '@/components/AppModal'
import axios from '@/utils/api'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import FILTRO_EMPTY from '@/models/filtro'
import { mapActions } from 'vuex'
import AppModalVisualizarCompleto from '../analise/components/modal/AppModalVisualizarCompleto.vue'
const BaseFiltro = require('@/screens/analise/listagem/' + process.env.ESTADO + '/BaseFiltro').default

export default {
  components: {
    AppAnexo,
    AppModal,
    AppListagem,
    Filtro,
    AppModalVisualizarCompleto
  },

  mixins: [
    AppNotificacao,
    BaseFiltro
  ],

  data () {
    return {
      idProcesso: null,
      numeroProcesso: null,
      tipoProcesso: null,
      protocolo: null,
      showModalVisualizarProcesso: false,
      anexos: [],
      items: [],
      processo: undefined,
      showModal: false,
      filtro: {...FILTRO_EMPTY('CAIXA_ENTRADA'), tipo: 'REGULARIZACAO_URBANA', caixa: 'CAIXA_PROCESSO'},
      totalElements: 0,
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', marcado: () => false, ordem: 1, acoes: [], type: 'icone', icone: 'comment-alt' },
        { id: 1, titulo: 'CPF/CNPJ do Interessado', propriedade: 'cpfCnpjInteressado', ordem: 2, acoes: [] },
        { id: 2, titulo: 'Nome/Razão Social do Interessado', propriedade: 'nomeRazaoSocialInteressado', ordem: 3, acoes: [] },
        { id: 3, titulo: 'Situação', propriedade: 'status', ordem: 4, acoes: [], exibir: () => true },
        { id: 4, titulo: 'Data Chegada', propriedade: 'dataChegadaSetor', ordem: 4, acoes: [] },
        { id: 5, titulo: 'Tipo de Processo', propriedade: 'tipo', ordem: 5, acoes: [] },
        { id: 6, titulo: 'Quantidade de fotos', propriedade: 'qtdFotos', ordem: 5, acoes: [], sortable: false },
        {
          id: 7, titulo: 'Ações', propriedade: 'tipo', ordem: 7, //eslint-disable-line
          acoes: [
            { id: 1, nome: 'Inserir fotos', icone: 'fa-upload', codigo: 'INSERIR_FOTOS', ordem: 1, show: () => true },
            { id: 2, nome: 'Visualizar Processo', icone: 'fa-eye', codigo: 'VISUALIZAR_PROCESSO', ordem: 2, show: this.showVisualizarProcesso }
          ]
        }
      ],
      configuracaoFiltro: {}
    }
  },

  computed: {
    titulo () {
      return `Adicionar foto no processo ${this.processo?.numeroProcesso}`
    }
  },

  created () {
    this.pesquisar()
  },

  methods: {
    ...mapActions({
      getUsuario: 'auth/getUsuario'
    }),

    async removeFile (documento) {
      this.confirmBox(this.$messages.DOCUMENTO_REMOVE_CONFIRM, this.$messages.TITULO_WARNING,
        () => {
          if (documento.id) {
            axios({
              method: 'DELETE',
              url: `documento/delete`,
              data: documento,
              responseType: 'blob'
            }).then(() => {
              this.deleteAnexo(documento)
            }).catch(() => {
              this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR,
                'Houve um erro ao remover o anexo.')
            })
          } else {
            this.deleteAnexo(documento)
          }
        },
        () => { })
    },

    deleteAnexo (documento) {
      if (documento.id) {
        const index = this.anexos.indexOf(this.anexos.find(a => a.id === documento.id))
        this.anexos.splice(index, 1)
      } else {
        const index = this.anexos.indexOf(this.anexos.find(a => a.key === documento.key))
        this.anexos.splice(index, 1)
      }
    },

    async getDownload (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.nome)
    },

    downloadDocumentoCadastro (documento) {
      this.getDownload(documento)
    },

    alteraTipoFoto (documento) {
      this.anexos.map((foto) => {
        if (foto.key === documento.key) {
          if (foto.tipo.id === 149) {
            foto.tipo = {
              id: 150,
              codigo: 'GALERIA'
            }
          } else {
            foto.tipo = {
              id: 149,
              codigo: 'ASSINATURA'
            }
          }
        }
      })
    },

    uploadFile (file) {
      this.anexos.push({
        key: file.response,
        nome: file.name,
        tipo: {
          id: 150,
          codigo: 'GALERIA'
        }
      })
    },

    INSERIR_FOTOS: (_this, { item }) => {
      _this.processo = item
      _this.showModal = true
    },

    VISUALIZAR_PROCESSO (_this, { item }) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.tipoProcesso = item.tipoCodigo
      this.protocolo = item.numeroProtocolo
      this.showModalVisualizarProcesso = true
    },

    showModalAnexar () {
      this.showModal = true
    },

    closeModal () {
      this.showModal = false
    },
    atualizarFiltro (novoFiltro) {
      this.filtroRapido = {...novoFiltro, tipo: 'REGULARIZACAO_URBANA', caixa: 'CAIXA_PROCESSO'}
    },
    async clearFiltro () {
      this.filtro = {...FILTRO_EMPTY(this.filtro.caixa), tipo: 'REGULARIZACAO_URBANA', caixa: 'CAIXA_PROCESSO'}
      this.filtro.pagina = 0
      const data = await this.buscar()
      this.items = data.content
      this.totalElements = data.totalElements
    },
    adicionarFotos () {
      axios({
        method: 'POST',
        url: `foto/add/${this.processo.id}`,
        data: this.anexos
      })
        .then(() => {
          this.processo = undefined
          this.anexos = []
          this.showModal = false
          this.pesquisar(this.filtro)
          this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Salvas com sucerro')
        })
        .catch(() => {
          this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro ao vincular imagens')
        })
    }
  }
}

</script>
<style>
.label {
  font-weight: bold;
}

.analise {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.card-collapse {
  border-radius: 10px;
  margin: 10px 0;
}

.btn-actions {
  display: flex;
  justify-content: space-between;
}

.flex {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.flex button {
  margin-bottom: 1em;
}

.flex .el-button span {
  display: flex;
}

.right {
  float: right;
}

.card-container {
  margin: 20px;
  border-radius: 10px;
}

.titulo-cadastar-foto {
  margin: 20px;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/screens/manutencao/CadastrarFotosReurb.vue